import React from 'react';
import {Form, Divider} from 'semantic-ui-react'

const ConfGenRot1 = ({autorizacUA, styles, handleChange, handleSubmit, args, handleClickRegr}) => {

//Traer autorizaciones
  // const a010105 = autorizacUA.findIndex( autorizac => autorizac === "010105" );

  if(args.numDocum){
    var numDocum = document.getElementById("numDocum");
    if(numDocum){numDocum.value = args.numDocum}
  }

  if(args.descrPlanta){
    var descrPlanta = document.getElementById("descrPlanta");
    if(descrPlanta){descrPlanta.value = args.descrPlanta}
  }
  if(args.descrSeccion){
    var descrSeccion = document.getElementById("descrSeccion");
    if(descrSeccion){descrSeccion.value = args.descrSeccion}
  }
  if(args.descrEquipo){
    var descrEquipo = document.getElementById("descrEquipo");
    if(descrEquipo){descrEquipo.value = args.descrEquipo}
  }
  if(args.descrComponente){
    var descrComponente = document.getElementById("descrComponente");
    if(descrComponente){descrComponente.value = args.descrComponente}
  }
  if(args.descrMecanismo){
    var descrMecanismo = document.getElementById("descrMecanismo");
    if(descrMecanismo){descrMecanismo.value = args.descrMecanismo}
  }

  return (
    <div>
      <Form onSubmit={()=>handleSubmit(args)}>
        <div>
          <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
            <i className="large search yellow icon"></i>
            Buscar
          </button>

          <div className="ui input fluid">
            <input id='numDocum' name="numDocum" type="number" placeholder="Traer XXX mecanismos" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrPlanta' autoComplete="off" name="descrPlanta" type="text" placeholder="Planta" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrSeccion' autoComplete="off" name="descrSeccion" type="text" placeholder="Sección" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrEquipo' autoComplete="off" name="descrEquipo" type="text" placeholder="Equipo" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrComponente' autoComplete="off" name="descrComponente" type="text" placeholder="Componente" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <div className="ui input fluid">
            <input id='descrMecanismo' autoComplete="off" name="descrMecanismo" type="text" placeholder="Mecanismo" style={styles.dropdown} onChange={handleChange}/>
          </div>
          <Divider inverted />
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
            <i className="large arrow left violet icon"></i>
            Regresar
          </button>
        </div>
      </Form>
    </div>
  )
};

export default ConfGenRot1
